import http from "@/api/http";
import { create } from "zustand";
import type { ICusTemplate } from "./interface/template";
import { message } from "antd";
import { GetLocalStorage, JsonParse } from "@/utils/helper";

interface State {
  type: string;
  config: any;
  templates: ICusTemplate[];
  loading: boolean;
}

interface Actions {
  setConfig: (conf: any) => void;
  fetchTemplates: () => Promise<void>;
  saveConfig: (conf: any) => Promise<ICusTemplate | null>;
  updateConfig: (id: string, conf: any) => Promise<ICusTemplate | null>;
  publishTemplate: (id: string, serial: string) => Promise<boolean>;
}

const initState: State = {
  type: "",
  config: null,
  templates: [],
  loading: false,
};

function parseConfig(template: ICusTemplate): ICusTemplate {
  if (template.config && typeof template.config === "string") {
    try {
      return { ...template, config: JsonParse(template.config) };
    } catch {
      return template;
    }
  }
  return template;
}

const templateStore = create<State & Actions>((set, get) => ({
  ...initState,
  setConfig: (conf) => {
    set({ config: conf });
  },
  fetchTemplates: async () => {
    set({ loading: true });
    try {
      const serial = await GetLocalStorage("scan-storage", "serial");
      const res = await http.get(`/cus-templates?chip_serial=${serial}`);
      if (res.status === 200) {
        const templates = (res.data as ICusTemplate[]).map(parseConfig);
        set({ templates, loading: false });
      } else {
        set({ loading: false });
      }
    } catch (error) {
      console.log("error", error);
      set({ loading: false });
    }
  },
  saveConfig: async (conf) => {
    try {
      const res = await http.post("/cus-templates", conf);
      if (res.status === 201) {
        const template = parseConfig(res.data as ICusTemplate);
        set({ type: template.type, config: template.config });
        message.success("Tạo template thành công!");
        return template;
      }
      return null;
    } catch (error) {
      console.log("error", error);
      message.error("Tạo template thất bại!");
      return null;
    }
  },
  updateConfig: async (id, conf) => {
    try {
      const res = await http.put(`/cus-templates/${id}`, conf);
      if (res.status === 200) {
        message.success("Cập nhật template thành công!");
        get().fetchTemplates();
        return parseConfig(res.data as ICusTemplate);
      }
      return null;
    } catch (error) {
      console.log("error", error);
      message.error("Cập nhật template thất bại!");
      return null;
    }
  },
  publishTemplate: async (id, serial) => {
    try {
      const res = await http.post(`/cus-templates/${id}/publish`, { chip_serial: serial });
      if (res.status === 200) {
        message.success("Publish template thành công!");
        // Refresh danh sách
        get().fetchTemplates();
        return true;
      }
      return false;
    } catch (error) {
      console.log("error", error);
      message.error("Publish template thất bại!");
      return false;
    }
  },
}));

export default templateStore;
